"use client";

import React, { Dispatch, SetStateAction } from "react";
import { SupAmountInput } from "@repo/ui-widgets";

import { useAmountState } from "@/components/Web3/Common/AmountState";
import config from "@/../config/dapp.config";
import type { SupWeb3Balance, SupWeb3TxSingleVault } from "@/types";
import useChainInfo from "@/hooks/useChainInfo";

interface SupWeb3StepFundingAmountProps {
  selectedBalance: SupWeb3Balance;
  vaultList: SupWeb3TxSingleVault[];
  setVaultList: Dispatch<SetStateAction<SupWeb3TxSingleVault[]>>;
  onSwitchToken: () => void;
}

const inputConfig = {
  fiatMaxDecimals: config.decimalsRoundingLimit,
  tokenMaxDecimals: config.decimalsBigRoundingLimit,
};

export default function Web3DepositFundingAmount(props: SupWeb3StepFundingAmountProps) {
  const { selectedBalance } = props;
  const { data: chainData } = useChainInfo(selectedBalance.chainId);

  const { totalAmount, updateTotalAmount } = useAmountState();

  return (
    <div className="mb-6 inline-flex w-full flex-col items-start justify-start gap-1">
      {chainData && (
        <SupAmountInput
          className="w-full"
          label="FUNDING AMOUNT"
          value={totalAmount}
          balance={selectedBalance}
          chain={chainData}
          config={inputConfig}
          sliderMarks={25}
          onChange={value => updateTotalAmount?.(value || "0")}
          onSwitchToken={props.onSwitchToken}
        />
      )}
    </div>
  );
}
